import React from 'react';
import { Trans } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import { getYear } from 'date-fns';

// Import utilities
import { useOperators } from 'components/utilities';

// Import components
import FooterNav from './FooterNav';
import FooterSocial from './FooterSocial';
import FooterPayments from './FooterPayments';

// Import styles
import { FooterStyled, FooterSide, FooterSideInfo } from './styles';

const Footer = () => {
	const { isOperator } = useOperators();
	const year = getYear(new Date());

	return (
		<FooterStyled>
			<FooterStyled.Content expanded={!isOperator}>
				<FooterSide>
					<FooterNav />
				</FooterSide>
				<FooterStyled.Copyrights>
					<Trans
						i18nKey="common_footer_copyrights"
						values={{ year, version: process.env.REACT_APP_VERSION }}
					/>
				</FooterStyled.Copyrights>
				<FooterSideInfo>
					{!isOperator && <FooterPayments />}
					<FooterSocial />
				</FooterSideInfo>
			</FooterStyled.Content>
		</FooterStyled>
	);
};

export default withRouter(Footer);
